<template>
    <div>
        <h2 class="header">Выводы:</h2>
        <table>
            <tr>
                <td class="label">Рекомендация(расчёт)</td>
                <td class="value">{{recommendation}}</td>
            </tr>
        </table>
    </div>
</template>

<script>
    export default {
        name: "Conclusion",
        computed: {
            recommendation() {
                return this.$store.getters.Q_ONE.recommendation
            }
        }
    }
</script>

<style scoped>
    .header {
        text-align: left;
        padding-bottom: 0;
        margin-bottom: 0;
    }

    table {
        margin-top: 0;
        width: 100%;
        margin-bottom: 20px;
    }

    table, th, td {

        border: 1px solid black;
        border-collapse: collapse;
    }

    th, td {
        padding: 5px;
        text-align: right;
    }

    .label, .value {
        width: 50%;
    }

    select {
        width: 100%;
    }
    .value {
        text-align: left;
    }
</style>